import { FC } from 'react';
import { clientDetailTabs, clientValidation } from './add-edit-client';
import { Tab, Tabs } from '@mui/material';

interface IAddEditClientTabs {
  errors: any;
  additionalContactsErrorsAreAllNull: boolean;
  selectedTab: clientDetailTabs;
  setSelectedTab: (value: clientDetailTabs) => void;
  clientDetailTabLinks: (
    | {
        name: string;
        url: string;
        value: clientDetailTabs;
        validation: clientValidation;
      }
    | {
        name: string;
        url: string;
        value: clientDetailTabs;
        validation?: undefined;
      }
  )[];
  setFieldTouched: (field: string) => void;
  values: any;
  validateForm: () => void;
  validateField: (field: string) => void;
}

export const AddEditClientTabs: FC<IAddEditClientTabs> = ({
  errors,
  additionalContactsErrorsAreAllNull,
  selectedTab,
  setSelectedTab,
  clientDetailTabLinks,
  setFieldTouched,
  values,
  validateForm,
  validateField
}) => {
  const isTabRed = (linkValidation, additionalContactsErrorsAreAllNull) => {
    if (
      linkValidation === clientValidation.additionalContacts &&
      additionalContactsErrorsAreAllNull
    ) {
      return false;
    }
    return !!linkValidation;
  };

  return (
    <Tabs
      value={selectedTab}
      indicatorColor="primary"
      textColor="primary"
      onChange={(_, value) => {
        setSelectedTab(value);
      }}
      variant="scrollable"
      allowScrollButtonsMobile
      sx={{
        marginTop: theme => theme.spacing(-0.75),
        marginBottom: theme => theme.spacing(2),
        borderBottom: theme => `1px solid ${theme.palette.grey[400]}`
      }}
    >
      {clientDetailTabLinks.map(link => {
        return (
          <Tab
            key={`${link.value}`}
            value={link.value}
            id={`${link.name}`}
            aria-controls={`${link.name}`}
            label={`${link.name}`}
            sx={{
              color: isTabRed(errors[link.validation], additionalContactsErrorsAreAllNull)
                ? theme => theme.palette.error.main
                : undefined
            }}
          />
        );
      })}
    </Tabs>
  );
};
